import { api } from "./api";

const chapterRewardsService = api.injectEndpoints({
    endpoints: (builder) => ({

        //saveJournal
        saveChapterReward: builder.mutation({
            query: (data) => ({
                url: "chapterReward/savechapterReward",
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: data,
            })
        }),
       
        paginationchapterReward: builder.mutation({
            query: (data) => ({
                url: "chapterReward/getAllchapterRewardPagination",
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: data,
            }),
        }),
        getchapterRewardById: builder.query({
            query: (id) => "chapterReward/get/" + id,
        }),
        updatechapterReward: builder.mutation({
            query: (data) => ({
                url: `chapterReward/update/${data.id}`,
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: data,
            }),
          }),
          deletechapterReward: builder.mutation({
            query: (id) => ({
              url: "chapterReward/delete/"+ id,
              method: "PUT",
              headers: { "Content-Type": "application/json" },
            }),
          }),
          // enableDisablechapterReward: builder.query({
          //   query: (id) => ({
          //     url: "chapterReward/enableDisable/" + id,
          //     method: "put"
          //   })
          // }),
          enableDisablechapterReward: builder.query({
            query: (id) => ({
                url: "chapterReward/enableDisable/" + id,
                method: "put"
            })
        }),
    }),
    overrideExisting: false,
});

export const {
  useSaveChapterRewardMutation,
  useUpdatechapterRewardMutation,
  useLazyGetchapterRewardByIdQuery,
  useDeletechapterRewardMutation,
  useLazyEnableDisablechapterRewardQuery,
  usePaginationchapterRewardMutation,
} = chapterRewardsService;